import { apiClient } from "./ApiClient";

export const loginApi = (user) => apiClient.post(`/authenticate`, user);
export const logoutApi = (user) => apiClient.post(`/api/logout`);
export const changePasswordApi = (passwordData) => apiClient.post(`/api/change-password`, passwordData);
